import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from "antd";
const DetailsSkeleton = ()=>/*#__PURE__*/ _jsxs("div", {
        className: "rc-account-v2-details-card",
        "aria-busy": "true",
        "aria-live": "polite",
        "aria-label": "Loading account details",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "rc-account-v2-details-card__head",
                "aria-hidden": true,
                children: [
                    /*#__PURE__*/ _jsx(Skeleton.Input, {
                        active: true,
                        size: "small",
                        style: {
                            width: 160,
                            height: 16
                        }
                    }),
                    /*#__PURE__*/ _jsx("br", {}),
                    /*#__PURE__*/ _jsx(Skeleton.Input, {
                        active: true,
                        size: "small",
                        style: {
                            width: 310,
                            height: 13,
                            marginTop: 8
                        }
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "rc-account-v2-details-card__body",
                "aria-hidden": true,
                children: /*#__PURE__*/ _jsxs("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 16
                    },
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                gap: 6
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Skeleton.Input, {
                                    active: true,
                                    size: "small",
                                    style: {
                                        width: 48,
                                        height: 13
                                    }
                                }),
                                /*#__PURE__*/ _jsx(Skeleton.Input, {
                                    active: true,
                                    block: true,
                                    style: {
                                        height: 32
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            style: {
                                display: "flex",
                                gap: 16
                            },
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    style: {
                                        flex: 1,
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 6
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Skeleton.Input, {
                                            active: true,
                                            size: "small",
                                            style: {
                                                width: 72,
                                                height: 13
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(Skeleton.Input, {
                                            active: true,
                                            block: true,
                                            style: {
                                                height: 32
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    style: {
                                        flex: 1,
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 6
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Skeleton.Input, {
                                            active: true,
                                            size: "small",
                                            style: {
                                                width: 64,
                                                height: 13
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(Skeleton.Input, {
                                            active: true,
                                            block: true,
                                            style: {
                                                height: 32
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            style: {
                                display: "flex",
                                justifyContent: "flex-end"
                            },
                            children: /*#__PURE__*/ _jsx(Skeleton.Button, {
                                active: true,
                                style: {
                                    width: 110
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
export { DetailsSkeleton };
